(() => {
  const initialiseCarousel = (page) => {
    if (!page || page.dataset.rslShowcaseReady === "true") return;

    const track = page.querySelector("[data-rsl-product-track]");
    const previous = page.querySelector("[data-rsl-prev]");
    const next = page.querySelector("[data-rsl-next]");
    const controls = page.querySelector("[data-rsl-controls]");
    const filterButtons = page.querySelectorAll("[data-rsl-filter]");
    const cards = [...page.querySelectorAll(".rsl-ring-card")];
    const count = page.querySelector("[data-rsl-result-count]");

    if (!track || !previous || !next) return;

    page.dataset.rslShowcaseReady = "true";

    const visibleCards = () => cards.filter((card) => !card.hidden);

    const updateControls = () => {
      const maximumScroll = Math.max(
        0,
        track.scrollWidth - track.clientWidth,
      );

      if (controls) controls.hidden = maximumScroll <= 5;

      previous.disabled = track.scrollLeft <= 5;
      next.disabled = track.scrollLeft >= maximumScroll - 5;
    };

    const move = (direction) => {
      const firstVisibleCard = visibleCards()[0];
      const gap =
        Number.parseFloat(window.getComputedStyle(track).columnGap) || 16;

      const distance = firstVisibleCard
        ? firstVisibleCard.getBoundingClientRect().width + gap
        : track.clientWidth * 0.82;

      track.scrollBy({
        left: direction * distance,
        behavior: "smooth",
      });
    };

    const applyFilter = (selectedButton) => {
      const selectedFilter = selectedButton.dataset.rslFilter || "all";

      filterButtons.forEach((button) => {
        button.setAttribute(
          "aria-pressed",
          button === selectedButton ? "true" : "false",
        );
      });

      cards.forEach((card) => {
        const styles = (card.dataset.style || "").split(" ");
        card.hidden =
          selectedFilter !== "all" && !styles.includes(selectedFilter);
      });

      if (count) {
        const total = visibleCards().length;
        count.textContent = `${total} ${total === 1 ? "design" : "designs"}`;
      }

      track.scrollTo({
        left: 0,
        behavior: "smooth",
      });

      window.requestAnimationFrame(updateControls);
    };

    previous.addEventListener("click", () => move(-1));
    next.addEventListener("click", () => move(1));

    track.addEventListener("scroll", updateControls, {
      passive: true,
    });

    track.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        move(-1);
      }

      if (event.key === "ArrowRight") {
        event.preventDefault();
        move(1);
      }
    });

    filterButtons.forEach((button) => {
      button.addEventListener("click", () => applyFilter(button));
    });

    page.querySelectorAll("img").forEach((image) => {
      if (!image.complete) {
        image.addEventListener("load", updateControls, {
          once: true,
        });
      }
    });

    if ("ResizeObserver" in window) {
      const resizeObserver = new ResizeObserver(updateControls);
      resizeObserver.observe(track);
    } else {
      window.addEventListener("resize", updateControls, {
        passive: true,
      });
    }

    updateControls();
  };

  const initialiseWithin = (scope) => {
    const pages = [];

    if (scope.matches?.("[data-rsl-carat-page]")) {
      pages.push(scope);
    }

    scope
      .querySelectorAll?.("[data-rsl-carat-page]")
      .forEach((page) => pages.push(page));

    pages.forEach(initialiseCarousel);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initialiseWithin(document);
    });
  } else {
    initialiseWithin(document);
  }

  document.addEventListener("shopify:section:load", (event) => {
    initialiseWithin(event.target);
  });
})();